// Publishes a device command exactly like the Flutter devController():
//   payload `[<uno>]<message>#<userId>`  ->  topic `<uno>/device`
import { publishMessage } from '../mqtt/mqttClient';

export function publishCommand(uniqueNumber, message, userId) {
  const payload = `[${uniqueNumber}]${message}#${userId}`;
  publishMessage(`${uniqueNumber}/device`, payload);
  return payload;
}
